<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout
            :headertext="$t('Tax.HSNaster.List')"
            :contenttext="$t('Tax.HSNaster.TableHeaderContent')"
          >
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="items.length === 0 && !loading"
                eheader="HSN Master"
                econtent="HSN Master"
                eimg="/src/assets/Img/icons/hsnmaster.svg"
                @createNew="IsAdd"
              />
              <div class="table-width-80">
                <Tableview
                  v-if="items.length !== 0"
                  :value="items"
                  :paginator="true"
                  class="p-datatable-gridlines"
                  :rows="10"
                  :rowHover="true"
                  filterDisplay="menu"
                  :loading="loading1"
                  responsiveLayout="scroll"
                  :columns="headers"
                  @row-click=""
                  :globalFilterFields="globalFilterFields"
                  :filters="filters"
                  selectionMode="single"
                  :exceldownload="true"
                >
                  <template v-slot:Add>
                    <span class="add">
                      <AddButton
                        @click="IsAdd()"
                        :btnname="$t('btn.plusaddnew')"
                        class="float-rights my-3"
                      >
                      </AddButton>
                    </span>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption
                      @ExportExcel="ExportExcel"
                      @ExportPDF="ExportPDF"
                      :ExportList="ExportList"
                      PageName="HSN Master"
                      :ExportOption="ExportOption"
                      class="ms-2"
                      :HideAndShow="true"
                    />
                  </template>
                  <template v-slot:Status="{ data }">
                    <!-- <Badge v-if="data.IsActive == '1'" severity="success">{{
                      "Active"
                    }}</Badge>
                    <Badge v-if="data.IsActive == '0'" severity="warning">{{
                      "InActive"
                    }}</Badge> -->
                    <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                    <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button
                        icon="pi pi-ellipsis-v"
                        class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)"
                      />
                    </span>
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty
                v-if="items.length === 0 && !loading"
                eheader="HSN Master"
                econtent="HSN Master"
                eimg="/src/assets/Img/icons/hsnmaster.svg"
                @createNew="IsAdd"
              />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items">
                    <div
                      class="d-flex align-items-center justify-content-between gap-2"
                    >
                      <div>
                        <p class="light-name">{{ item.HSNCode }}</p>
                        <p class="name">{{ item.HSNName }}</p>
                        <p class="light-name">{{ item.Code }}</p>
                      </div>
                      <div class="d-flex align-items-center">
                        <div>
                          <!-- <Badge v-if="item.IsActive == '0'" severity="warning">{{
            "InActive"
          }}</Badge>
                          <Badge v-if="item.IsActive == '1'" severity="success">{{
            "Active"
          }}</Badge> -->
                          <OrangeStatus
                            name="InActive"
                            v-if="item.IsActive == '0'"
                          />
                          <GreenStatus
                            name="Active"
                            v-if="item.IsActive == '1'"
                          />
                        </div>
                        <i
                          class="pi pi-ellipsis-v"
                          @click="toggle($event, item)"
                        ></i>
                      </div>
                    </div>
                    <p class="light-name">Purchase Tax: {{ item.PurchaseTaxName || '-' }}</p>
                    <p class="light-name">Sales Tax: {{ item.SalesTaxName || '-' }}</p>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
      <HSNCreation
        v-model:trigger="showDialog"
        v-if="showDialog"
        v-model:selected-item="editItems"
        @load="IsShow(), (showDialog = false)"
        @close="showDialog = false"
        @loaderhide="loading = false"
        @loadershow="loading = true"
        :OperationID="ObjOperationId"
        :EntityId="EntityData.EntityId"
      />

      <Menu
        ref="menu"
        id="overlay_menu"
        :model="itemListed"
        @click=""
        :popup="true"
      />
      <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
      <InActivatedSuccessfully
        :visible="pop.inactivepop"
        @ok="closetrigger()"
      />
      <EditConfirmation
        :Editmodel="Editmodel"
        @yes="IsEdit(dataEdit)"
        @no="Editmodel = false"
        :content="$t('confirmation.editcontent')"
      />
      <DeleteConfirmationVue
        :DeleteModel="Deletemodel"
        :content="contentdel"
        @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false"
      />
      <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
      <Mapping
        :visible="MappingPop.visible"
        @ok="closetrigger()"
        :content="MappingPop.content"
      />
    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, h, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import HSNCreation from "../../../Masters/Tax/HSN/HSNCreation.vue";
import HsnService from "../../../../../../modules/Inventory/Service/HsnService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    Mapping,
    DeletedSuccessfully,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,
    Tableview,
    HSNCreation,
    EditConfirmation,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    let loading = ref(false);
    const toast = useToast();
    const showDialog = ref(false);
    const dataEdit = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const editItems = ref();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let loading1 = ref(false);
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();

    let List = ref([]);

    function IsAdd() {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data, Status) {
      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t("confirmation.activecontent");
        } else if (Status == 2) {
          contentdel.value = t("confirmation.inactivecontent");
        } else {
          contentdel.value = t("confirmation.deletecontent");
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    //Delete-Popup
    let delId = 0;

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }
    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      datas.value = data;

      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: InActivevisible,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(datas.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(datas.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(datas.value, 2);
            },
          },
        ],
      },
    ]);

    //DataTable Fields
    const headers = [
      {
        header: t("Tax.HSNaster.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("Tax.HSNaster.HSNCode"),
        field: "HSNCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("Tax.HSNaster.Code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("Tax.HSNaster.Name"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("Tax.HSNaster.PurchaseTax"),
        field: "PurchaseTaxName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("Tax.HSNaster.SalesTax"),
        field: "SalesTaxName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("Tax.HSNaster.Status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "",
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        const response = await HsnService.getdata(usersData.OrganizationId);
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    //DataTable Array
    let items: any = ref([]);
    const IsShow = async () => {
      try {
        debugger;
        loading.value = true;
        const response = await HsnService.getdata(usersData.OrganizationId);
        let count = 0;

        response["result"] = response["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;
          item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
          return item;
        });

        items.value = response["result"];
        console.log(items.value);
        loading.value = false;
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    };

    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }
    const MappingPop = ref({
      visible: false,
      content: "",
    });

    //categorydelete function
    const IsDelete = async (data) => {
      loading.value = true;

      try {
        let response: any = "";
        if (data.ActiveStatus == 0) {
          response = await HsnService.deletedata(
            data.Id,
            Number(usersData.OrganizationId)
          );
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          response = await HsnService.active(
            data.Id,
            status,
            Number(usersData.OrganizationId)
          );
        }
        let message = response["ErrorInfo"].ErrorCode;
        const resultObj = JSON.parse(response["result"]);
        if (resultObj.result != "True" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = resultObj.result;
          loading.value = false;

          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;

        alert(error);
      }
    };

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      HSNCode: { value: null, matchMode: FilterMatchMode.IN, options: items },
      HSNName: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ptax: { value: null, matchMode: FilterMatchMode.IN, options: items },
      stax: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },

      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    return {
      EntityData,
      ObjOperationId,
      MappingPop,
      IsConfirmDel,
      IsConfirmEdit,
      Deletemodel,
      deletepop,
      closetrigger,
      IsDelete,
      IsShow,
      headers,
      items,
      filters,
      globalFilterFields,
      filteredColumns,
      loading,
      loading1,
      IsAdd,
      showDialog,
      editItems,
      IsEdit,
      Editmodel,
      dataEdit,
      RowClick,
      List,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilecategorycode {
  font-size: 14px;
  margin-top: -5px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
